<template>

  <validation-provider
    #default="{ errors }"
    ref="myinput"
    :name="label"
    :vid="label"
    :rules="'date_format:DD/MM/YYYY|'+rules"
  >
    <b-form-group
      :label="label"
      :label-for="name"
      :class="{'disabled': readonly || disabled}"
    >
      <b-input-group
        :state="errors.length > 0 ? false:null"
      >
        <b-form-input
          v-model="display"
          v-mask="'##/##/####'"
          debounce="500"
          :state="errors.length > 0 ? false:null"
          :placeholder="placeholder"
          :name="name"
        />
        <b-input-group-append>
          <b-form-datepicker
            v-model="inputValue"
            size="sm"
            v-bind="$attrs"
            button-only
            right
            bottom
            :state="errors.length > 0 ? false:null"
            button-variant="outline-secondary"
            locale="pt-BR"
            style="height: 99%!important;"
            v-on="$listeners"
            @context="onContext"
          />
        </b-input-group-append>
      </b-input-group>
      <small class="text-danger">{{ errors[0] }}</small>

    </b-form-group>
  </validation-provider>
</template>

<script>
import {required, dateFormat} from '@core/utils/validations/validations'
import {ValidationProvider} from 'vee-validate'
import moment from 'moment-timezone'
import {
  BFormDatepicker, BFormInput, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'

export default {
  name: 'I2FormInputDate',
  components: {
    ValidationProvider,
    BFormDatepicker,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,

  },
  props: {
    value: {
      type: [String],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    rules: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    inputValue: '',
    errors: [],
    display: '',
    required,
    dateFormat,
  }),

  watch: {
    value(val) {
      if (val === '' || val === null) {
        this.display = ''
        return
      }
      this.display = moment(val, 'DD/MM/YYYY').format('DD/MM/YYYY')
    },
    inputValue(val) {
      if (val === '') {
        this.$emit('input', val)
      }
      let format = 'DD/MM/YYYY'
      if (val.indexOf('-') > 0) {
        format = 'YYYY-MM-DD'
      }
      const date = String(moment(val).format(format))
      this.$emit('input', date)
    },
    display(val) {
      if (val === '') {
        this.$emit('input', '')
      }
      const formatedDated = moment(val, 'DD/MM/YYYY', true)
      if (formatedDated.isValid()) {
        if (formatedDated.format('DD/MM/YYYY') !== this.value) {
          this.$emit('input', formatedDated.format('DD/MM/YYYY'))
        }
      }
    },
  },
  mounted() {
    if (this.value === '' || this.value === null) {
      this.display = ''
      return
    }
    this.display = moment(this.value, 'DD/MM/YYYY').format('DD/MM/YYYY')
  },
  methods: {
    onContext(ctx) {
      let val = this.value
      if (!this.display) {
        let format = 'DD/MM/YYYY'
        if (val.indexOf('-') > 0) {
          format = 'YYYY-MM-DD'
        }

        let theValue = ''
        if (val !== '' && val) {
          theValue = moment(val, format).format('DD/MM/YYYY')
        }
        this.display = theValue
        this.inputValue = theValue
      }
      if (ctx.selectedYMD && ctx.selectedYMD.length) {
        const date = String(moment(ctx.selectedYMD).format('L'))
        this.display = date
      }
    },
  },
}
</script>

<style>

</style>
